import {
  Button,
  Checkbox,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Label,
} from '@fluentui/react-components';
import React, { useState } from 'react';
import { onChangeShowUnsavedDialog } from '../../../@data/actions';

export interface IDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onAgree?: () => void;
}
export const UnsavedReportDialog = (props: IDialogProps) => {
  const { isOpen, setIsOpen, onAgree } = props;
  const [isChecked, setIsChecked] = useState(false);

  const handleOnAgree = () => {
    if (isChecked) {
      onChangeShowUnsavedDialog();
    }
    onAgree?.();
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => setIsOpen(data.open)} modalType="non-modal">
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Report is not Saved</DialogTitle>

          <DialogContent>
            <Label>Your report is not saved. Switching to another page will lose your edits.</Label>
            <Checkbox
              label="I understand. Don’t remind me anymore."
              checked={isChecked}
              onChange={(e, data) => data.checked !== 'mixed' && setIsChecked(data.checked)}
            />
          </DialogContent>
          <Button appearance="primary" onClick={handleOnAgree}>
            Agree
          </Button>
          <DialogTrigger disableButtonEnhancement>
            <Button appearance="secondary">Close</Button>
          </DialogTrigger>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
